let model = {};

// dữ liệu form
model.dataForm = {};

// validation form
model.validForm = {};

// dữ liệu mẫu các form khác
model.dataFormOther = {
   
};

// validation các form khác
model.validFormOther = {};


model.tableRules = {
    data: [],
    lengthMenu: [15, 30, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 15,
    offset: 0,
    sort: "employee_no",
    defaultSort: ["", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            year: "",
            company_id: "",
            employee_no: "",
            "administrative_info.name.full_name": "",
            "job_info.department_id": "",
            "job_info.position_id": "",
            condition: "",
            allow_dayoff_number: "",
            unallow_dayoff_number: ""
        },
        valid: {
            year: [],
            company_id: [],
            employee_no: [],
            "administrative_info.name.full_name": [],
            "job_info.department_id": [],
            "job_info.position_id": [],
            condition: [],
            allow_dayoff_number: [],
            unallow_dayoff_number: []
        },
        operator: {
            year: "",
            company_id: ":in:",
            employee_no: ":regex_i:",
            "administrative_info.name.full_name": ":regex_i:",
            "job_info.department_id": "",
            "job_info.position_id": "",
            condition: "$vn_text=",
            allow_dayoff_number: "",
            unallow_dayoff_number: ""
        }
    }
};

export default model;
